module.exports = __webpack_public_path__ + "img/documents.3bad33d5.svg";